/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audio_Stems_Loaded_LabelInputs */

const en_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Loaded: ${i?.name}`)
};

const fr_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chargée : ${i?.name}`)
};

const de_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geladen: ${i?.name}`)
};

const it_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricata: ${i?.name}`)
};

const ru_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загружено: ${i?.name}`)
};

const es_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cargada: ${i?.name}`)
};

const zh_cn2_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已加载：${i?.name}`)
};

const ja_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`読み込み済み：${i?.name}`)
};

const hi_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लोड किया गया: ${i?.name}`)
};

const pt_pt2_audio_stems_loaded_label = /** @type {(inputs: Audio_Stems_Loaded_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carregada: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Loaded: {name}" |
*
* @param {Audio_Stems_Loaded_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_loaded_label = /** @type {((inputs: Audio_Stems_Loaded_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Loaded_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_stems_loaded_label(inputs)
	if (locale === "de") return de_audio_stems_loaded_label(inputs)
	if (locale === "it") return it_audio_stems_loaded_label(inputs)
	if (locale === "ru") return ru_audio_stems_loaded_label(inputs)
	if (locale === "es") return es_audio_stems_loaded_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_stems_loaded_label(inputs)
	if (locale === "ja") return ja_audio_stems_loaded_label(inputs)
	if (locale === "hi") return hi_audio_stems_loaded_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_stems_loaded_label(inputs)
	return en_audio_stems_loaded_label(inputs)
});